import React from "react";
import axios from "axios";
import join from "url-join";
import authenService from "../utils/services/authenService";
import { store } from "../utils/redux/store";
import _ from "lodash";
import jwt_decode from "jwt-decode";
import { login } from "../utils/redux/actions/authenAction";
// import https from "https";
// const https = require('https');

const instance = axios.create();
let isAbsoluteURLRegex = /^(?:\w+:)\/\//;

instance.interceptors.request.use(async (config) => {
  const states = store.getState();
  // //console.log("states", states)
  const _authenService = new authenService();
  let accessToken = states.authenReducer.accessToken;
  const refreshToken = states.authenReducer.refreshToken;
  const accessTokenExp = states.authenReducer.tokenExpire;
  const username = states.authenReducer.username;
  const password = states.authenReducer.password;
  const cutomerId = states.customerProfileReducer.customerId;
  const d1 = new Date();
  const d2 = new Date(accessTokenExp * 1000);
  const Lang = localStorage.getItem("lang");
  console.log("config", config.url);

  if (d2 < d1) {
    const result = await _authenService.refreshToken(refreshToken);
    const response = _.get(result, "data");
    const decoded = jwt_decode(response.access_token);
    store.dispatch(
      login(
        response.access_token,
        response.expires_in,
        response.refresh_expires_in,
        response.refresh_token,
        response.token_type,
        response.session_state,
        response.scope,
        decoded.sub,
        decoded.exp,
        username,
        password
      )
    );
    accessToken = response.access_token;
  }

  // //console.log('Envvv', config.url.indexOf('/v3/business-partner/manager/') !== -1);

  const auth = accessToken;
  var url = `${process.env.REACT_APP_BASE_URL}`;
  var port = ``;

  if (!isAbsoluteURLRegex.test(config.url)) {
    if (config.url.indexOf("/v3/business-partner/manager/") !== -1) {
      port = `${process.env.REACT_APP_BUSINESS_PARTNER_MANAGER_PORT}`;
    } else if (
      config.url.indexOf("/v1/resource/manager/search/location/type/") !== -1
    ) {
      port = `${process.env.REACT_APP_RESOURCE_MANAGER_PORT}`;
    } else if (config.url.indexOf("v5/order/manager/company/") !== -1) {
      port = `${process.env.REACT_APP_ORDER_MANAGER_PORT_V5}`;
    } else if (config.url.indexOf("web/public/order/tracking") !== -1) {
      url = `${process.env.REACT_APP_URL_Tracking}`;
    } else if (
      config.url.indexOf("/v5/business-partner/manager/company/") !== -1
    ) {
      port = `${process.env.REACT_APP_BUSINESS_PARTNER_MANAGER_PORT}`;
    } else if (config.url.indexOf("/v1/warehouse/manager/company/") !== -1) {
      port = `${process.env.REACT_APP_WAREHOUSE_MANAGER_PORT}`;
    } else if (config.url.indexOf("/v1/container/manager/company/") !== -1) {
      port = `${process.env.REACT_APP_CONTAINER_MANAGER_PORT}`;
    } else if (config.url.indexOf("/v5/item/manager/company/") !== -1) {
      port = `${process.env.REACT_APP_ITEM_MANAGER_PORT}`;
    } else if (config.url.indexOf("/queue/manager/company/") !== -1) {
      port = `${process.env.REACT_APP_QUEUE_MANAGER_PORT}`;
    } else if (
      config.url.indexOf("/language/company") !== -1 ||
      config.url.indexOf("/resource/manager/company/") !== -1
    ) {
      port = `${process.env.REACT_APP_RESOURCE_MANAGER_PORT}`;
    }
  }

  // baseURL: `${process.env.REACT_APP_BASE_URL}:${process.env.REACT_APP_BUSINESS_PARTNER_MANAGER_PORT}`,
  config.url = join(`${url}:${port}`, config.url);
  config.headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Max-Age": "86400",
    "Access-Control-Allow-Credentials": "true",
    "Access-Control-Allow-Headers": "Content-Type",
    "Content-Type": "application/json",
    Authorization: "Bearer " + auth,
    Memcomid: cutomerId,
    lang: Lang,
  };

  return config;
});

export { instance };
